/*
 * <frank-card-rotator> — alterna (crossfade) as fotos de um card de produto na listagem.
 * Frank Debourge · vitrine editorial (eyewear).
 *
 * Comportamento:
 *  - Só anima enquanto o card está visível (IntersectionObserver) e a aba está ativa.
 *  - Stagger: cada instância começa com um pequeno atraso baseado na ordem, para os
 *    cards não piscarem em sincronia.
 *  - Respeita `prefers-reduced-motion`: não anima, mantém a 1ª foto (capa) estática.
 *  - data-interval (ms) controla a velocidade; o crossfade em si é via CSS (opacity).
 */
(function () {
  if (customElements.get('frank-card-rotator')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let instanceCount = 0;

  class FrankCardRotator extends HTMLElement {
    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('img'));
      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 3000;
      this.current = 0;
      this.timer = null;
      this.visible = false;
      this.stagger = (instanceCount++ % 6) * 300; // espalha o início em até ~1.5s

      if (this.images.length < 2 || reduceMotion.matches) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.start();
          else this.stop();
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this);

      this._onVisibility = () => {
        if (document.hidden) this.stop();
        else if (this.visible) this.start();
      };
      document.addEventListener('visibilitychange', this._onVisibility);
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
      if (this._onVisibility) {
        document.removeEventListener('visibilitychange', this._onVisibility);
      }
    }

    start() {
      if (this.timer || document.hidden) return;
      this.classList.add('is-rotating');
      const tick = () => this.advance();
      // primeiro avanço com stagger; depois, ritmo constante
      this.timer = window.setTimeout(() => {
        this.advance();
        this.timer = window.setInterval(tick, this.interval);
      }, this.interval + this.stagger);
    }

    stop() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    advance() {
      this.images[this.current].classList.remove('is-active');
      this.current = (this.current + 1) % this.images.length;
      this.images[this.current].classList.add('is-active');
    }
  }

  customElements.define('frank-card-rotator', FrankCardRotator);
})();
